import React, { useState, useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { API_URL } from './tools/consts';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';

export default function Animation() {

    const [timeLeft, setTimeLeft] = useState(300); // 5 minutes en secondes
    const [isRunning, setIsRunning] = useState(false);
    const [hasStarted, setHasStarted] = useState(false); // Indique si le timer a été lancé au moins une fois
    const [showResumeButton, setShowResumeButton] = useState(false); // Contrôle l'affichage du bouton "Reprendre"
    const navigate = useNavigate();
    const [listPlayers, setListPlayers] = useState([]);


    // Gestion du timer
    useEffect(() => {
        let timer;
        if (isRunning && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
        } else if (timeLeft === 0) {
            setIsRunning(false); // Arrête le timer quand il atteint 0
        }
        return () => clearInterval(timer); // Nettoie l'intervalle
    }, [isRunning, timeLeft]);

    // Formatage du temps en minutes:secondes
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const getScorePoints = async () => {
        const qr = await fetch(API_URL + "players/bests/animation", {
            method: "GET",
        });
        const json = await qr.json();
        const playersArray = Object.values(json);
        setListPlayers(playersArray);
    };

    useEffect(() => {
        const fetchScoresPeriodically = () => {
            getScorePoints(); // Appelle l'API pour récupérer les scores
            setTimeout(fetchScoresPeriodically, 3000); // Répète toutes les 3 secondes
        };

        fetchScoresPeriodically(); // Démarre le processus

        return () => clearTimeout(fetchScoresPeriodically); // Nettoie en cas de démontage
    }, []);

    return (
        <div
            style={{
                backgroundImage: 'url(/Couverture.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                position: 'relative',
            }}
        >
            <Button variant="contained" color="error" onClick={() => navigate('/')} className="back-button" style={{
                marginRight: 'auto',
                marginLeft: "2em", top: '0', left: '0', position: 'absolute', marginTop: "3em"
            }}>
                Retour à l'accueil
            </Button>

            {/* Timer en haut à droite */}
            <Typography
                variant="h6" // Utilisation de 'h6' pour réduire la taille du texte
                style={{
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    padding: '5px 10px',
                    borderRadius: '10px',
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    fontSize: '70px', // Taille réduite du texte
                }}
            >
                {formatTime(timeLeft)}
            </Typography>

            {/* Boutons sous le timer */}
            <div style={{
                position: 'absolute',
                top: '8.5em', // Positionne les boutons juste sous le timer
                right: '0px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                width: '13em'
            }}>
                {!hasStarted && (
                    <Button
                        onClick={() => {
                            setIsRunning(true); // Lance ou reprend le timer
                            setHasStarted(true); // Indique que le timer a été démarré
                        }}
                        variant="contained"
                        color="success"
                    >
                        Lancer la session de jeu
                    </Button>
                )}
                {showResumeButton && (
                    <Button
                        onClick={() => {
                            setIsRunning(true); // Relance le timer
                            setShowResumeButton(false); // Cache le bouton "Reprendre"
                        }}
                        variant="contained"
                        color="success"
                    >
                        Reprendre
                    </Button>
                )}
                <Button
                    onClick={() => {
                        setIsRunning(false); // Met en pause le timer
                        setShowResumeButton(true); // Affiche le bouton "Reprendre"
                    }}
                    variant="contained"
                    color="error"
                >
                    Pause
                </Button>
                <Button
                    onClick={() => {
                        setTimeLeft(300); // Réinitialise à 5 minutes
                        setIsRunning(false); // Arrête le timer
                        setHasStarted(false); // Réinitialise l'état de démarrage
                        setShowResumeButton(false); // Cache le bouton "Reprendre"
                    }}
                    variant="contained"
                    color="primary"
                >
                    Réinitialiser
                </Button>
            </div>

            <img src='/logo_o.png' alt='' style={{ width: '15vw', textAlign: 'center', position: 'absolute', top: '50px' }} />

            <div className="medias" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '35vh', height: '80vh' }}>
                <img src='/demo.gif' alt='' style={{ height: '50vh', marginLeft: '8vh' }} />
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                ></div>
                <div style={{
                    borderRadius: '10px',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    width: '90%',
                    maxWidth: '600px',
                    marginBottom: '5vh',
                    maxHeight: '80%',
                    marginRight: '5em'
                }}>
                    {listPlayers.map((player, index) => (
                        <Card
                            key={player.id}
                            style={{
                                width: '100%',
                                height: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '10px 20px',
                                backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#e0e0e0',
                                border: '1px solid #ccc',
                                borderRadius: '10px',
                            }}
                        >
                            <CardHeader
                                avatar={
                                    index === 0 ? (
                                        <Avatar sx={{ bgcolor: '#FFD700' }}>
                                            {index + 1}
                                        </Avatar>
                                    ) : index === 1 ? (
                                        <Avatar sx={{ bgcolor: '#C0C0C0' }}>
                                            {index + 1}
                                        </Avatar>
                                    ) : index === 2 ? (
                                        <Avatar sx={{ bgcolor: '#cd7f32' }}>
                                            {index + 1}
                                        </Avatar>
                                    ) : (
                                        <Avatar sx={{ bgcolor: '#1976d2' }}>
                                            {index + 1}
                                        </Avatar>
                                    )
                                }
                                title={<Typography variant="h6">{player.username}</Typography>}
                            />
                            <CardContent>
                                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                                    {player.points} points
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </div>
                <div>
                    <img src='/qr-code.png' alt='' style={{ marginLeft: '5em', marginTop: '50%', height: '15vw', marginRight: '8vh' }} />
                    <Typography variant="h6" style={{ fontWeight: 'bold'}}>
                        https://www.lorangedenoel.fr/
                    </Typography>
                </div>
            </div>
        </div>
    );
}
